import { useEffect, useState } from "react";
import { api } from "@/lib/api";

/** Final-verdict fusion: compares the live AI signal with the Quant Engine v2
 *  stance on the same index and renders a combined verdict badge. */
export const QuantAgreement = ({ symbol, direction }) => {
  const [op, setOp] = useState(null);
  useEffect(() => {
    let alive = true;
    setOp(null);
    if (!symbol) return;
    api.get(`/quant/opinion?symbol=${symbol}`)
      .then(({ data: d }) => { if (alive) setOp(d); })
      .catch((e) => console.error("quant opinion fetch failed:", e?.message || e));
    return () => { alive = false; };
  }, [symbol, direction]);
  if (!op || !op.covered) return null;
  let tone, label, note;
  if (op.decision === "trade" && op.direction === direction) {
    tone = "border-[#22C55E]/50 bg-[#22C55E]/10 text-[#22C55E]";
    label = "FINAL VERDICT: DOUBLE CONFIRMED";
    note = `Quant Engine v2 independently confirms ${direction} (${op.probability}%). Highest-conviction setup.`;
  } else if (op.decision === "trade" && op.direction && op.direction !== direction) {
    tone = "border-[#EF4444]/50 bg-[#EF4444]/10 text-[#EF4444]";
    label = "ENGINES CONFLICT — CAUTION";
    note = `Quant Engine v2 sees ${op.direction} instead. Conflicting engines = skip or half-size.`;
  } else if (op.regime && op.regime !== "trending") {
    tone = "border-[#F59E0B]/50 bg-[#F59E0B]/10 text-[#F59E0B]";
    label = `QUANT V2: REGIME ${String(op.regime).toUpperCase()}`;
    note = "Quant engine won't trade this regime — single-engine signal, reduce conviction.";
  } else {
    tone = "border-zinc-700 bg-zinc-800/30 text-zinc-400";
    label = "QUANT V2: NO INDEPENDENT CONFIRMATION";
    note = "Setup criteria not met on the 10-layer engine yet — single-engine signal.";
  }
  return (
    <div className={`border px-3 py-2 ${tone}`} data-testid="quant-agreement">
      <div className="text-[10px] font-mono uppercase tracking-widest font-bold" data-testid="quant-agreement-label">{label}</div>
      <div className="text-[10px] text-zinc-400 leading-snug mt-0.5">{note}</div>
    </div>
  );
};
